import { render, staticRenderFns } from "./selfInputPropertyNumber.vue?vue&type=template&id=3339d70c"
import script from "./selfInputPropertyNumber.vue?vue&type=script&lang=js"
export * from "./selfInputPropertyNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports